/** Precio de catálogo para la web: priceNet + IVA, siempre a 2 decimales. */
export function refAmount(value) {
  if (value === null || value === undefined || value === '') return '';
  const amount = Number(value);
  return Number.isFinite(amount) ? amount.toFixed(2) : '';
}
